import './MainLayout.scss'

export { default as MainLayout } from './MainLayout'